import { Component, Input } from '@angular/core';
import { PropertyListModel } from '../../models/property-list.model';
import { RouterModule } from '@angular/router';
import { MapService } from '../../services/map.service';
import { ApiImagePipe } from '../../pipes/image.pipe';
import { SettingsModel } from '../../models/setting.model';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-property-list-property',
  standalone: true,
  imports: [RouterModule, ApiImagePipe, MatTooltipModule],
  templateUrl: './property-list-property.component.html',
  styleUrl: './property-list-property.component.scss',
})
export class PropertyListPropertyComponent {
  @Input() property: PropertyListModel = new PropertyListModel();
  @Input() settings: SettingsModel = new SettingsModel();

  @Input() showShortDescriptionText: boolean = false;
  @Input() locationId: number = 0;
  @Input() properties?: PropertyListModel[];
  @Input() fromMap: boolean = false;
  @Input() wider = false;

  constructor(private mapService: MapService) {}

  openWindow() {
    this.mapService.setMarkedProperty(this.property);
  }

  getRating(size: number): number[] {
    return Array.from({ length: size }, (_, index) => index);
  }
}
